<template>
  <div class="address-window-component">
    <v-loader v-if="isLoading" absolute />
    <s-tabs>
      <s-tab
        name="Доставка"
        class="delivery-tab"
        :selected="currentTab === 'delivery'"
      >
        <template v-if="!showAddressForm">
          <h1 class="step-title font-weight-regular">
            Адреса клиента:
          </h1>
          <div class="button-group d-flex justify-between">
            <v-row dense class="justify-space-between">
              <v-col sm="5">
                <!--                <v-btn
                  @click="stepBack"
                  class="button button-back"
                  width="100%"
                  color="#F1F3F6"
                >
                  <font-awesome-icon icon="chevron-left" />
                  Вернуться назад
                </v-btn>-->
              </v-col>
              <v-col sm="5">
                <v-btn
                  class="button button-apply"
                  width="100%"
                  color="#F1F3F6"
                  :disabled="
                    !currentAddressId && !isYandexDelivery && !isDeliveryClub
                  "
                  @click="updateAddress"
                >
                  <font-awesome-icon icon="check" />
                  Подтвердить адрес
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <v-checkbox
            v-show="isSourceYandex || isYandexDelivery"
            v-model="isYandexDelivery"
            label="Доставляет Яндекс курьер"
            hide-details="auto"
            class="crm-checkbox mb-10"
            @change="isDeliveryClub = false"
          />

          <v-checkbox
            v-show="isSourceDeliveryClub || isDeliveryClub"
            v-model="isDeliveryClub"
            label="Доставляет Delivery Club курьер"
            hide-details="auto"
            class="crm-checkbox mb-10"
            @change="isYandexDelivery = false"
          />

          <div
            v-if="!isYandexDelivery && !isDeliveryClub"
            class="address-section"
          >
            <staggering-list-transitions no-leave-delay>
              <v-address
                v-for="(item, i) in addressItems"
                :key="item.id"
                v-model="currentAddressId"
                :item="item"
                :checked="item.id === currentAddressId"
                :data-index="i"
                @onEdit="openEditAddress"
                @onDelete="confirmDeleteAddress"
              />
            </staggering-list-transitions>
            <!--              <transition-group name="list" tag="div">-->

            <!--              </transition-group>-->

            <template
              v-if="
                !addressItems.length &&
                  !isLoading &&
                  basket.basketSource !== 'yandex'
              "
            >
              <span class="d-block display-3 text-center">Нет адресов</span>
            </template>
          </div>

          <delete-confirm-dialog
            v-model="showDeleteAddressConfirm"
            :loading="deleting"
            @confirm="deleteAddress"
          >
            <div>
              <div>Вы действительно хотите удалить адрес?</div>
              <div class="deleting-address-name">
                {{ deletedAddressName }}
              </div>
            </div>
          </delete-confirm-dialog>

          <div
            v-if="!isYandexDelivery && !isDeliveryClub"
            class="new-address-section"
          >
            <!--            <span class="label">Новый адрес:</span>-->
            <v-btn
              class="button-add"
              width="100%"
              dark
              depressed
              @click="openNewAddressWindow"
            >
              <span class="d-flex flex-column align-center font-weight-medium">
                <font-awesome-icon icon="plus" />
                Новый адрес
              </span>
            </v-btn>
          </div>
        </template>

        <transition name="fade">
          <address-form
            v-if="showAddressForm"
            :client-id="clientId"
            :edit-item="editItem"
            @hide="showAddressForm = false"
            @new-address-created="onNewAddressCreated"
            @address-edited="onNewAddressCreated"
          />
        </transition>
      </s-tab>

      <s-tab
        name="Самовывоз"
        class="pickup-tab"
        :selected="currentTab === 'pickup'"
      >
        <h1 class="step-title font-weight-regular">
          Самовывоз:
        </h1>

        <div class="button-group d-flex justify-between">
          <v-row dense class="justify-space-between">
            <v-col sm="5">
              <!--              <v-btn
                @click="stepBack"
                class="button button-back"
                width="100%"
                color="#F1F3F6"
              >
                <font-awesome-icon icon="chevron-left"/>
                Вернуться назад
              </v-btn>-->
            </v-col>
            <v-col sm="5">
              <v-btn
                class="button button-apply"
                width="100%"
                color="#F1F3F6"
                :disabled="!pickupPoint || isFilialLocked(pickupPoint)"
                @click="setPickupPoint"
              >
                <font-awesome-icon icon="check" />
                Сохранить пункт самовывоза
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <div class="addresses-section">
          <span class="label">Выберите пункт самовывоза:</span>
          <v-text-field
            v-model="pickupPointSearch"
            append-icon="mdi-magnify"
            label="Поиск..."
            class="pb-4"
            outlined
            single-line
            hide-details
          ></v-text-field>
          <template v-if="filteredPickupPointFilials.length">
            <v-row>
              <v-col
                v-for="item in filteredPickupPointFilials"
                :key="`pp-${item.id}`"
                sm="4"
                class="pickup-point-col"
              >
                <pickup-point
                  v-model="pickupPoint"
                  name="point"
                  :value="item.id"
                  :item="item"
                  :checked="item.id === pickupPoint"
                  @change="currentAddressId = null"
                />
              </v-col>
            </v-row>
          </template>
          <template v-else-if="pickupPointSearch">
            <span class="d-block display-3 text-center">Ничего не найдено</span>
          </template>
          <template v-else>
            <span
              class="d-block display-3 text-center"
            >Нет пунктов самовывоза</span>
          </template>
        </div>
      </s-tab>
    </s-tabs>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import VAddress from '@/components/order-processing/order-components/second-step/Address'
  import PickupPoint from '@/components/order-processing/order-components/second-step/PickupPoint'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import _ from 'lodash'
  import STabs from '@/components/ui/tabs/STabs.vue'
  import STab from '@/components/ui/tabs/STab.vue'
  import BasketSource from '@/models/enums/BasketSource'
  import DeliveryType from '@/models/enums/DeliveryType'
  import FilialDataService from '@/services/api/FilialDataService'
  import AddressForm from '@/components/order-processing/order-components/address-window/AddressForm.vue'
  import DeleteConfirmDialog from '@/components/ui/dialogs/DeleteConfirmDialog.vue'
  import ClientAddressDataService from '@/services/api/ClientAddressDataService'
  import gsap from 'gsap'
  import StaggeringListTransitions from '@/components/ui/transitions/StaggeringListTransitions.vue'

  export default {
    name: 'AddressWindow',
    components: {
      StaggeringListTransitions,
      DeleteConfirmDialog,
      AddressForm,
      STab,
      STabs,
      VLoader,
      VAddress,
      PickupPoint,
    },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        isLoading: false,
        isYandexDelivery: false,
        isDeliveryClub: false,
        // addressItems: [],
        showAddressForm: false,
        currentTab: 'delivery',
        pickupPoint: '',
        currentKeyboard: 'street',
        city: '',
        street: '',
        house: '',
        apartment: '',
        apartmentNumber: '',
        floor: '',
        entry: '',
        timeout: null,
        suggests: [],
        currentAddressId: '',
        editItem: null,
        streetObj: {},
        houseObj: {},
        pickupPointSearch: '',
        addressToDelete: null,
        showDeleteAddressConfirm: false,
        deleting: false,
      }
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
        client: (state) => state.clients.clientsSingle,
        availableForOrderFilials: (state) =>
          state.branches.availableForOrderFilials,
      }),
      ...mapGetters({
        addressItems: 'clients/getClientsAddress',
        isFilialLocked: 'baskets/isFilialLocked',
      }),
      filteredPickupPointFilials () {
        return this.availableForOrderFilials.filter((filial) => {
          return (
            filial.hasPickup &&
            filial.name
              .toLowerCase()
              .indexOf(this.pickupPointSearch.toLowerCase()) > -1
          )
        })
      },
      deletedAddressName () {
        return this.addressToDelete?.fullAddress
      },
      isNewOrderPage () {
        return this.$route.name === 'newOrder'
      },
      order () {
        return this.isNewOrderPage ? this.newOrder : this.fastOrder
      },
      orderEditPrefix () {
        return this.isNewOrderPage ? 'newOrder' : 'fastOrder'
      },
      clientId () {
        return this.basket?.client?.id
        /*  return this.isNewOrderPage
          ? this.basket?.client?.id
          : this.order?.client?.id */
      },
      isSourceYandex () {
        return this.basket.basketSource === BasketSource.Yandex
      },
      isSourceDeliveryClub () {
        return this.basket.basketSource === BasketSource.DeliveryClub
      },
      isHouseInputDisabled () {
        return _.isEmpty(this.streetObj)
      },
      streetId () {
        return this.streetObj ? this.streetObj.id : null
      },
      hasGeoData () {
        return this.houseObj ? this.houseObj.hasGeo : false
      },
      fullHouseAddress () {
        return [this.city, this.street, this.house].join(', ')
      },
      getLatitude () {
        return this.hasGeoData ? this.houseObj.latitude : null
      },
      getLongitude () {
        return this.hasGeoData ? this.houseObj.longitude : null
      },
    },
    watch: {
      basket () {
        this.setDeliveryTab()
      },
    },
    created () {
      if (this.basket.clientAddress && this.basket.clientAddress.id) {
        this.currentAddressId = this.basket.clientAddress.id
      }
      if (this.basket.deliveryType === 'yandex') {
        this.isYandexDelivery = true
      }
      if (this.basket.deliveryType === 'deliveryClub') {
        this.isDeliveryClub = true
      }
      this.getAddresses({ setLast: false })
      this.$store.dispatch('branches/fetchAvailableForOrderFilials')
      this.setDeliveryTab()
    },
    methods: {
      confirmDeleteAddress (address) {
        this.addressToDelete = address
        this.showDeleteAddressConfirm = true
      },
      async deleteAddress () {
        if (this.addressToDelete) {
          this.deleting = true
          console.log('delete', this.addressToDelete)
          try {
            await ClientAddressDataService.delete(this.addressToDelete.id)
            _.remove(this.addressItems, (address) => {
              return address.id === this.addressToDelete.id
            })
            this.addressToDelete = null
            this.showDeleteAddressConfirm = false
          } catch (e) {
            this.showErrorFromResponse(e)
          }

          this.deleting = false
        }
      },
      onNewAddressCreated (id) {
        this.getAddresses({ setLast: false, setId: id })
      },
      onSelectHouse (obj) {
        console.log({ selectHouse: obj })
        this.houseObj = obj || {}
      },
      clearHouse () {
        this.house = null
      },
      onSelectStreet (obj) {
        console.log({ selectStreet: obj })
        this.streetObj = obj
        this.city = obj ? obj.city : ''
      },
      saveBasketSource (source) {
        this.basket.basketSource = source
        const data = {
          basketSource: source,
        }
        const id = this.basket.id
        this.$store.dispatch('baskets/updateBasket', { data, id }).then((res) => {
          if (res.status === 200) {
            this.reloadBasket()
          } else {
            this.showErrorMessage(res.response.data.message)
          }
        })
      },
      setCityFromSearch () {
        if (this.suggests.length === 1) {
          this.city = this.suggests[0].city
        }
      },
      setAddressData (suggest) {
        this.city = suggest.city
        this.street = suggest.street
      },
      openNewAddressWindow () {
        this.city = ''
        this.street = ''
        this.house = ''
        this.apartment = ''
        this.apartmentNumber = ''
        this.entry = ''
        this.floor = ''
        this.showAddressForm = true

        this.editItem = null
      },
      openEditAddress (item) {
        this.city = item.city || ''
        this.street = item.street || ''
        this.house = item.house || ''
        this.apartment = item.apartment || ''
        this.apartmentNumber = item.apartmentNumber || ''
        this.entry = item.entry || ''
        this.floor = item.floor || ''

        this.currentEditItemId = item.id
        this.editItem = item

        this.showAddressForm = true
      },

      setPickupPoint () {
        this.isLoading = true
        const id = this.basket.id
        // console.log(this.pickupPoint)
        const data = {
          filialId: this.pickupPoint,
        }
        this.$store
          .dispatch('baskets/changeDeliveryToPickup', { data, id })
          .then((res) => {
            if (res.status === 200) {
              this.showSuccessMessage('Точка самовывоза установлена')
              this.$store.commit(
                this.orderEditPrefix + '/setSecondStepWindow',
                'payment',
              )
              this.afterSetNewDeliveryAddress()
              this.reloadBasket()
            } else {
              this.showErrorMessage(res.response.data.message)
            }
            this.isLoading = false
          })
      },
      updateAddress () {
        this.isLoading = true
        const id = this.basket.id
        if (this.isYandexDelivery) {
          this.$store
            .dispatch('baskets/changeOnYandexDelivery', id)
            .then((res) => {
              if (res.status === 200) {
                this.$store.commit(
                  this.orderEditPrefix + '/setSecondStepWindow',
                  'payment',
                )
                this.afterSetNewDeliveryAddress()
                this.reloadBasket()
              } else {
                this.showErrorMessage(res.response.data.message)
              }
            })
            .finally(() => {
              this.isLoading = false
            })
        } else if (this.isDeliveryClub) {
          this.$store
            .dispatch('baskets/changeOnDeliveryClub', id)
            .then((res) => {
              if (res.status === 200) {
                this.$store.commit(
                  this.orderEditPrefix + '/setSecondStepWindow',
                  'payment',
                )
                this.afterSetNewDeliveryAddress()
                this.reloadBasket()
              } else {
                this.showErrorMessage(res.response.data.message)
              }
            })
            .finally(() => {
              this.isLoading = false
            })
        } else {
          const data = {
            clientAddressId: this.currentAddressId,
          }
          this.$store
            .dispatch('baskets/updateBasketAddress', { data, id })
            .then((res) => {
              if (res.status === 200) {
                this.showSuccessMessage('Адрес обновлен')
                this.$store.commit(
                  this.orderEditPrefix + '/setSecondStepWindow',
                  'payment',
                )
                this.afterSetNewDeliveryAddress()
                this.reloadBasket()
              } else {
                this.showErrorMessage(res.response.data.message)
              }
              this.isLoading = false
            })
        }
      },
      afterSetNewDeliveryAddress () {
        this.$store.commit(this.orderEditPrefix + '/setStep', 2)
      },
      reloadBasket () {
        this.$store
          .dispatch('baskets/fetchSingleBasket', this.basket.id)
          .then((res) => {
            if (res.status !== 200) {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      stepBack () {
        this.$store.commit(this.orderEditPrefix + '/setStep', 1)
      },
      setTab (tab) {
        this.currentTab = tab
      },
      getAddresses ({ setLast = false, setId = null }) {
        const payload = {
          clientId: this.basket.client.id,
          limit: 100000,
        }
        this.isLoading = true

        this.$store
          .dispatch('clients/fetchClientsAddressList', payload)
          .then((res) => {
            // this.addressItems = res.data.items
            if (this.addressItems.length) {
              this.updateAddressItemsSort(setLast, setId)
            } else {
              this.openNewAddressWindow()
            }
          })
          .catch((err) => {
            this.showErrorFromResponse(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      updateAddressItemsSort (setLast, setId) {
        this.addressItems.sort((a, b) => {
          if (a.id < b.id) {
            return 1
          }
          if (a.id > b.id) {
            return -1
          }
          return 0
        })

        if (setId) {
          this.currentAddressId = setId
        } else if (setLast) {
          this.currentAddressId = this.addressItems[0].id
        }
      },
      setDeliveryTab () {
        console.log('setDeliveryTab', this.basket.deliveryType)
        if (this.basket.deliveryType === 'self') {
          this.currentTab = 'pickup'
          this.pickupPoint = this.basket.filialId
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.address-window-component {
  background-color: #fafafa;

  font-size: 12px;

  .media-xl({
    font-size: 14px;
    // padding-top: 30px;
  });

  .filials-section {
    margin-bottom: 24px;

    .label {
      font-size: 24px;
      display: block;
    }
  }

  .tabs {
    margin-bottom: 33px;
    border-bottom: 1px solid #d4d4d4;

    .tab {
      flex: 1;
      outline: none;
      font-size: 24px;
      line-height: 21px;
      border-radius: 14px 14px 0 0;
      height: 57px;

      &.active {
        background-color: #191919;
        font-weight: 900;
        color: @color-primary;
      }
    }
  }

  .step-title {
    font-size: 2.42em;
    line-height: 1;
    margin-bottom: 0.97em;
  }

  .button-group {
    margin-bottom: 21px;

    .button {
      height: 80px;
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;

      svg {
        margin-right: 8px;
      }
    }

    .button-back {
      border-radius: 10px;

      svg {
        .fill-svg(#0033ff);
      }
    }

    .button-apply {
      background-color: @color-success !important;
      color: #ffffff;
      border-radius: 10px;

      &.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        box-shadow: none !important;

        svg {
          .fill-svg(#00000042);
        }
      }

      svg {
        .fill-svg(#ffffff);
      }
    }
  }

  .address-section {
    margin-bottom: 22px;
  }

  .new-address-section {
    .label {
      display: block;
      font-size: 24px;
      line-height: 21px;
      margin-bottom: 25px;
    }

    .button-add {
      background-color: @color-primary !important;
      height: 6.7em;

      svg {
        width: 20px;
        height: 20px;
        margin-bottom: 12px;
      }
    }
  }

  // Вкладки доставки и самовывоза на компактном десктопе: кнопка подтверждения
  // стоит в одной строке с заголовком, а не отдельной строкой под ним - всё, что
  // ниже, поднимается. 73px - высота блока кнопки (65px в диапазоне, см. App.vue,
  // и поля колонки по 4px)
  .delivery-tab,
  .pickup-tab {
    .media-compact-pc({
      .step-title {
        line-height: 73px;
        margin-bottom: 0;
      }

      // значение задано владельцем; с полем колонки 4px под кнопкой выходит 19px
      .button-group {
        margin-top: -73px;
        margin-bottom: 15px;
      }
    });
  }

  // Компактный десктоп: меньше воздуха под вкладками и вокруг поиска пунктов
  // самовывоза - высота экрана нужна спискам
  .media-compact-pc({
    ::v-deep .s-tabs-headers {
      margin-bottom: 12px;
    }

    .pickup-tab .addresses-section {
      .label {
        margin-bottom: 10px;
      }

      // !important - у класса pb-4 от Vuetify отступ с !important
      .v-input.pb-4 {
        padding-bottom: 4px !important;
      }
    }
  });

  .addresses-section {
    .label {
      display: block;
      font-size: 20px;
      line-height: 21px;
      margin-bottom: 31px;
    }

    // Уже 1300px пункты самовывоза - по одному в ряд, строкой, как адреса
    // доставки: слева название и адрес, справа часы работы и отметка выбора.
    // В три колонки карточки по 196px, название не помещается
    @media (max-width: 1299px) {
      .pickup-point-col {
        flex: 0 0 100%;
        max-width: 100%;
        padding-top: 6px;
        padding-bottom: 6px;
      }

      ::v-deep {
        // !important - у .flex-column и .d-flex от Vuetify свойства с !important
        .pickup-point-content {
          flex-direction: row !important;
          align-items: center;
          min-height: 0;
          padding: 14px 20px;

          // название с адресом и отметка становятся соседями блока с часами
          & > .d-flex {
            display: contents !important;

            & > .flex-column {
              flex: 1 1 0;
              min-width: 0;
              order: 1;
            }
          }
        }

        .pickup-point-content .point-name {
          margin-bottom: 2px;
          font-size: 18px;
        }

        .pickup-point_footer {
          flex: 0 0 auto;
          order: 2;
          margin: 0 16px;
        }

        .pickup-point_footer__left {
          max-width: none;
        }

        .checkmark {
          flex: 0 0 auto;
          order: 3;
        }
      }
    }
  }

  .text-field {
    &.v-input--is-focused {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500;
        }
      }
    }

    ::v-deep {
      .v-input__slot {
        height: 80px;
        background-color: @color-secondary;
        border-radius: 15px;

        input {
          font-size: 25px;
          line-height: 18px;
        }
      }
    }
  }

  .street-section {
    .streets {
      min-height: 104px;
    }

    .street-field {
      margin-bottom: 23px;
    }

    .label {
      display: block;
      margin-bottom: 14px;
      font-size: 20px;
      line-height: 21px;
    }

    .button {
      min-height: 80px;
      font-size: 24px;
      line-height: 18px;
      white-space: initial !important;
      background-color: @color-secondary !important;

      ::v-deep {
        .v-btn__content {
          display: block;
          word-break: break-all;
          width: 100%;
        }
      }
    }
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.5s ease;
  }

  .list-enter-from,
  .list-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
}

.deleting-address-name {
  font-weight: 300;
  color: #6d6d6dff;
  padding-top: 5px;
}
</style>
